// The Medicine Profile's own labels. The column builder, badge and formatters are the shared
// profile kit, re-exported so the report's files import from one place.

export * from '../shared/profileKit';

export const STOCK_STATUS_LABEL = {
  IN_STOCK: 'In stock',
  LOW_STOCK: 'Low stock',
  OUT_OF_STOCK: 'Out of stock',
  NEAR_EXPIRY: 'Near expiry',
  EXPIRED: 'Expired',
};

export const MOVEMENT_REASON_LABEL = {
  DISPENSE: 'Given to a patient',
  RECEIPT: 'Received',
  RECEIPT_EDIT: 'Receipt corrected',
  RECEIPT_CANCEL: 'Receipt cancelled',
  ADJUSTMENT: 'Adjustment',
};

export const OUTCOME_LABEL = {
  GIVEN: 'Given',
  ON_UNPAID_BILL: 'On a bill not yet paid',
  NOT_FINISHED: 'Prescription not finished',
  NOT_BILLED: 'Not billed',
  BILL_CANCELLED: 'Bill cancelled',
};

export const OUTCOME_TONE = {
  GIVEN: 'green',
  ON_UNPAID_BILL: 'amber',
  NOT_FINISHED: 'grey',
  NOT_BILLED: 'grey',
  BILL_CANCELLED: 'red',
};

/** How a sale's cost was arrived at, in the words the Dispensing table shows. */
export const COST_BASIS_LABEL = {
  EXACT: 'From its batches',
  ESTIMATE: 'Partly estimated',
  NOT_DEDUCTED: 'Stock not deducted',
  UNKNOWN: 'No cost on record',
};

export const CATEGORY_LABEL = { MEDICINE: 'Medicine', SUPPLY: 'Supply' };

// Packaging as the catalogue shows it: BOX is called a Pack there.
export const PACKAGING_LABEL = { BOX: 'Pack' };

export const BEDSIDE_ROLE_LABEL = {
  'clinical.bedsidesugar.lancet.id': 'the lancet for a bedside blood sugar check',
  'clinical.bedsidesugar.strip.id': 'the test strip for a bedside blood sugar check',
};
